export interface Credential {
  id: string;
  type: string;
  fileUrl: string;
  expirationDate?: string;
}

export interface Document {
  id: string;
  type: string;
  fileUrl: string;
}

export interface ContractorProfile {
  name: string;
  address: string;
  profileImage: string;
  scopeOfPractice: string;
  credentials: Credential[];
  documents: Document[];
}
